import { v4 as uuidv4 } from "uuid";
import { NoteBlock } from "../block";
export interface VolumeBlock extends NoteBlock {
  "volume-id": string;
  type: "omega/query-omega/page/block/volume/VolumeBlock";
}
export function isVolumeBlock(block: NoteBlock): block is VolumeBlock {
  return (block as VolumeBlock)["volume-id"] !== undefined;
}
export const newVolumeBlock = (config: {
  appId: string; pageId: string; volumeId: string; blockIndex: number;
}): VolumeBlock => {
  const { appId, pageId, volumeId, blockIndex } = config;
  return {
    "volume-id": volumeId,
    type: "omega/query-omega/page/block/volume/VolumeBlock",
    "block-index": blockIndex, "page-id": pageId, "app-id": appId, "block-id": uuidv4(),
  };
};
